import { render, staticRenderFns } from "./AirwayTopControls.vue?vue&type=template&id=567942b0&scoped=true&"
import script from "./AirwayTopControls.vue?vue&type=script&lang=js&"
export * from "./AirwayTopControls.vue?vue&type=script&lang=js&"
import style0 from "./AirwayTopControls.vue?vue&type=style&index=0&id=567942b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567942b0",
  null
  
)

export default component.exports